import { render, staticRenderFns } from "./experimentalRes.vue?vue&type=template&id=00c59344&scoped=true"
import script from "./experimentalRes.vue?vue&type=script&lang=js"
export * from "./experimentalRes.vue?vue&type=script&lang=js"
import style0 from "./experimentalRes.vue?vue&type=style&index=0&id=00c59344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c59344",
  null
  
)

export default component.exports